var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 179.33 84.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n        stroke: #8969d7;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-52, .cls-13, .cls-17, .cls-53, .cls-19, .cls-20, .cls-21, .cls-22, .cls-54, .cls-55, .cls-30, .cls-31, .cls-34, .cls-35, .cls-37, .cls-38, .cls-39, .cls-41, .cls-43, .cls-47, .cls-49, .cls-51 {\n        isolation: isolate;\n      }\n\n      .cls-2, .cls-12, .cls-17, .cls-19, .cls-21, .cls-30, .cls-43, .cls-47, .cls-51 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8, .cls-9, .cls-56, .cls-10, .cls-11, .cls-13, .cls-20, .cls-22, .cls-55, .cls-34, .cls-35, .cls-37, .cls-38, .cls-39, .cls-49 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-56 {\n        opacity: .7;\n      }\n\n      .cls-57, .cls-58 {\n        mix-blend-mode: lighten;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-12 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-59 {\n        stroke: #fff;\n        stroke-width: .04px;\n      }\n\n      .cls-59, .cls-53, .cls-54, .cls-55 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-59, .cls-46 {\n        fill: #fff;\n      }\n\n      .cls-16, .cls-53, .cls-54, .cls-55 {\n        fill: none;\n      }\n\n      .cls-17 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-53 {\n        stroke: url(#linear-gradient-15);\n      }\n\n      .cls-53, .cls-54 {\n        stroke-width: .81px;\n      }\n\n      .cls-53, .cls-54, .cls-31 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-19 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-21 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-54 {\n        stroke: url(#linear-gradient-18);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-55 {\n        stroke: url(#linear-gradient-17);\n        stroke-width: .5px;\n      }\n\n      .cls-30 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-31 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-58 {\n        opacity: .5;\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-32 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-36 {\n        fill: #68930c;\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-41 {\n        fill: url(#radial-gradient-7);\n        mix-blend-mode: color-dodge;\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-43 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-47 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-51 {\n        fill: url(#radial-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 43.81,
    x2: 179.33,
    y2: 43.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5833a4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -459.61,
    cy: 28.9,
    fx: -459.61,
    fy: 28.9,
    r: 1.01,
    gradientTransform: "translate(24032.17 -1492.35) scale(52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8160ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#482193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 125.71,
    y1: 811.79,
    x2: 127.34,
    y2: 814.44,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fce594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f6d17b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f2c168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#efb65a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#eeb052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#edae50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#eeb153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#f0b95d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f5c76e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fbda85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ffe794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b77946"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -289.74,
    cy: 260.5,
    fx: -289.74,
    fy: 260.5,
    r: 1.01,
    gradientTransform: "translate(1044.39 -796.27) scale(3.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3e8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f6eee7",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f6eee7",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f7f0e9",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f8f1eb",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f8f1eb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 129.01,
    y1: 815.11,
    x2: 126.91,
    y2: 811.93,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e7c883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d2a669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c38d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ba7e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#b77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 125.66,
    y1: 815.48,
    x2: 126.8,
    y2: 810.8,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 139.51,
    y1: 811.79,
    x2: 141.13,
    y2: 814.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -289.7,
    fx: -289.7,
    r: 1.01,
    gradientTransform: "translate(1058.06 -796.27) scale(3.17)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 142.8,
    y1: 815.11,
    x2: 140.7,
    y2: 811.93,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 139.45,
    y1: 815.48,
    x2: 140.6,
    y2: 810.8,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 132.61,
    y1: 807.5,
    x2: 134.24,
    y2: 810.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -289.72,
    cy: 260.48,
    fx: -289.72,
    fy: 260.48,
    r: 1.01,
    gradientTransform: "translate(1051.23 -800.52) scale(3.17)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 135.91,
    y1: 810.82,
    x2: 133.81,
    y2: 807.65,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 132.56,
    y1: 811.2,
    x2: 133.7,
    y2: 806.51,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 134.73,
    y1: 814.75,
    x2: 134.77,
    y2: 814.75,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffe794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fbda85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f5c76e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f0b95d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#eeb153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#edae50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#eeb052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#efb65a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f2c168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f6d17b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fce594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fff1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f7e398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e1bf7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#be844f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 118.93,
    y1: 829.3,
    x2: 147.88,
    y2: 829.3,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f2dc93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e0be7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d1a468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#c59159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#bd834e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#b87b48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#b77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#bf8148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e0a24e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#edae50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#613f1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 119.42,
    y1: 829.45,
    x2: 147.35,
    y2: 829.45,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 133.39,
    y1: 844.5,
    x2: 133.39,
    y2: 835.7,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#b77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 119.34,
    y1: 829.31,
    x2: 147.45,
    y2: 829.31,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 120.99,
    y1: 829.77,
    x2: 145.83,
    y2: 829.77,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#edae50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ebac4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e3a54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d59a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c28a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a9753d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#875934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff1a3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -425.08,
    cy: 75.98,
    fx: -425.08,
    fy: 75.98,
    r: 1.01,
    gradientTransform: "translate(5486.31 -906.74) scale(12.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#070D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#070D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#070D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070D27"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -442.82,
    cy: 51.79,
    fx: -442.82,
    fy: 51.79,
    r: 1.01,
    gradientTransform: "translate(9257.9 -1030.86) scale(20.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#faf7f3",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f9f6f2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f8f4ef",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f6f2eb",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f0e8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -426.09,
    cy: 74.58,
    fx: -426.09,
    fy: 74.58,
    r: 1.01,
    gradientTransform: "translate(5634.42 -915.71) scale(12.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edae50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e1a54c",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c28e42",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#906931",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4b361a",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23180d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 121.41,
    y1: 829.81,
    x2: 145.37,
    y2: 829.81,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#edae50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e2a54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c68e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#996839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#875934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8a5d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a98454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#c4a66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d9c180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ead790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f6e69b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fdeea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff1a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 133.54,
    y1: 831.41,
    x2: 145.91,
    y2: 831.41,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 134.69,
    y1: 814.76,
    x2: 134.73,
    y2: 814.76,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 119.01,
    y1: 827.41,
    x2: 122.94,
    y2: 827.41,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77946",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#b77946",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#b77946",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#b77946",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#b77946",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b77946",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#b77946",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#b77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 119.57,
    y1: 831.07,
    x2: 123.58,
    y2: 831.07,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 120.71,
    y1: 834.06,
    x2: 123.97,
    y2: 834.06,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 114.74,
    y1: 822.42,
    x2: 125.32,
    y2: 835.24,
    gradientTransform: "translate(0 -782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffe794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fbda85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f5c76e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f0b95d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#eeb153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#edae50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#eeb052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#efb65a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f2c168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f6d17b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fce594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fff1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f7e398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e1bf7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#be844f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b77946"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 114.28,
    y1: 824.77,
    x2: 124.65,
    y2: 836.27,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 118.13,
    y1: 830.01,
    x2: 124.54,
    y2: 838.5,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 112.67,
    y1: 827.19,
    x2: 122.72,
    y2: 827.19,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 115.38,
    y1: 831.54,
    x2: 123.37,
    y2: 831.54,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 118.31,
    y1: 834.47,
    x2: 123.8,
    y2: 834.47,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -330.77,
    cy: 157.31,
    fx: -330.77,
    fy: 157.31,
    r: 1.01,
    gradientTransform: "translate(1473.17 -814.43) scale(4.1 5.45)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -283.21,
    cy: 206.04,
    fx: -283.21,
    fy: 206.04,
    r: 1.01,
    gradientTransform: "translate(985.3 -792.28) scale(3.06 4.07)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -190.66,
    cy: 301.31,
    fx: -190.66,
    fy: 301.31,
    r: 1.01,
    gradientTransform: "translate(511.03 -768.35) scale(2.05 2.72)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 147.77,
    x2: 143.84,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 147.21,
    y1: 831.07,
    x2: 143.2,
    y2: 831.07,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 146.07,
    y1: 834.06,
    x2: 142.81,
    y2: 834.06,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 152.05,
    y1: 822.42,
    x2: 141.47,
    y2: 835.25,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 152.51,
    y1: 824.77,
    x2: 142.14,
    y2: 836.27,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 148.66,
    y1: 830.01,
    x2: 142.26,
    y2: 838.5,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 154.11,
    y1: 827.19,
    x2: 144.06,
    y2: 827.19,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 151.42,
    y1: 831.54,
    x2: 143.42,
    y2: 831.54,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 148.47,
    y1: 834.47,
    x2: 142.98,
    y2: 834.47,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -610.56,
    cy: -129.57,
    fx: -610.56,
    fy: -129.57,
    r: 1.01,
    gradientTransform: "translate(-2353.44 -665.26) rotate(-180) scale(4.1 5.45)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -658.14,
    cy: -178.3,
    fx: -658.14,
    fy: -178.3,
    r: 1.01,
    gradientTransform: "translate(-1865.57 -677.69) rotate(-180) scale(3.06 4.07)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -750.72,
    cy: -273.57,
    fx: -750.72,
    fy: -273.57,
    r: 1.01,
    gradientTransform: "translate(-1391.3 -693.84) rotate(-180) scale(2.05 2.72)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 17.33,
    width: 22.68,
    height: 20.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 28.67,
    y1: 66.83,
    x2: 28.67,
    y2: 87.61,
    gradientTransform: "translate(-.02 87.61) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2d54e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ebdd5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 2.81,
    width: 179.33,
    height: 82,
    rx: 12.11,
    ry: 12.11
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.13,
    y: 14.05,
    width: 59.53,
    height: 59.53,
    rx: 7.57,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M126.5,32.16l-1.19.65.25-1.33-.98-.93,1.34-.18.59-1.22.59,1.22,1.34.18-.98.93.25,1.33-1.19-.65h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M124.57,30.55l1.93.43v-1.84l-.59,1.22s-1.34.18-1.34.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M126.5,30.98l1.93-.43-.98.93.25,1.33-1.19-1.84h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M126.5,30.98l-1.19,1.84,1.19-.65v-1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M140.29,32.16l-1.19.65.25-1.33-.98-.93,1.34-.18.59-1.22.59,1.22,1.34.18-.98.93.25,1.33-1.19-.65h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M138.36,30.55l1.93.43v-1.84l-.59,1.22s-1.34.18-1.34.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M140.29,30.98l1.93-.43-.98.93.25,1.33-1.19-1.84h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M140.29,30.98l-1.19,1.84,1.19-.65v-1.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M133.4,27.88l-1.19.65.25-1.33-.98-.93,1.34-.17.59-1.22.59,1.22,1.34.17-.98.93.25,1.33-1.19-.65h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M131.47,26.27l1.93.43v-1.84l-.59,1.22-1.34.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M133.4,26.69l1.93-.43-.98.93.25,1.33-1.19-1.84h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M133.4,26.69l-1.19,1.84,1.19-.65s0-1.19,0-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M134.77,32.7v.11l-.04-.06.04-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.3,63.96s-.08-.02-.12-.04c-1.1-.39-2.17-.88-3.19-1.45-6.82-3.81-11.06-11.14-11.06-19.12v-9.2l.64.15c1.49.37,3.03.57,4.56.59,5.73,0,8.33-3.05,8.82-3.68.02-.03.04-.06.06-.08l.44-.51.4.61c.48.64,3.1,3.68,8.83,3.68,1.54-.02,3.07-.21,4.56-.59l.64-.15v9.2c0,7.98-4.24,15.31-11.06,19.12-1.03.58-2.1,1.07-3.21,1.46-.03.01-.07.02-.1.03l-.1.02-.1-.03h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M147.35,34.82v8.53c0,7.71-4.07,14.91-10.8,18.68-1,.55-2.05,1.03-3.14,1.41h-.07c-1.08-.38-2.13-.86-3.13-1.42-6.73-3.76-10.8-10.97-10.8-18.68v-8.52c9.33,2.23,13.36-2.55,13.92-3.32l.04-.05s.02.03.03.05c.57.77,4.59,5.55,13.92,3.32h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M122.15,53.88c1.89,3.42,4.68,6.24,8.08,8.14,1,.55,2.05,1.03,3.13,1.41h.07c1.08-.38,2.13-.86,3.13-1.42,3.4-1.91,6.19-4.73,8.08-8.14h-22.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M147.35,34.82v8.53c0,7.71-4.07,14.91-10.8,18.68-1,.55-2.05,1.03-3.14,1.41h-.07c-1.08-.38-2.13-.86-3.13-1.42-6.73-3.76-10.8-10.97-10.8-18.68v-8.52c9.33,2.23,13.36-2.55,13.92-3.32l.04-.05s.02.03.03.05c.57.77,4.59,5.55,13.92,3.32h.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M133.4,35.02c1.82,1.4,4.83,2.95,9.27,2.95.72,0,1.42-.04,2.13-.11v5.51c0,6.87-3.64,13.18-9.49,16.45-.62.34-1.26.66-1.92.93-.66-.27-1.29-.59-1.92-.93-5.85-3.27-9.48-9.57-9.48-16.45v-5.51c.71.07,1.42.11,2.13.11,4.44,0,7.46-1.53,9.27-2.95h.01ZM133.4,33.7l-.32.25c-1.64,1.35-4.53,2.97-8.94,2.97-.86,0-1.73-.06-2.57-.17l-.58-.08v6.68c0,7.24,3.83,13.88,10.01,17.33.72.4,1.46.76,2.22,1.07l.19.08.19-.08c.77-.3,1.5-.67,2.22-1.07,6.17-3.45,10.01-10.1,10.01-17.33v-6.66l-.58.08c-.86.11-1.72.17-2.57.17-4.42,0-7.3-1.61-8.94-2.97l-.32-.25h-.01v-.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M133.39,61.28c-.75-.29-1.46-.64-2.16-1.02-6.01-3.37-9.75-9.85-9.75-16.9v-6.08c.88.12,1.76.17,2.64.18,4.59,0,7.59-1.7,9.27-3.09,1.68,1.38,4.68,3.09,9.27,3.09.89,0,1.77-.06,2.64-.18v6.08c0,7.05-3.73,13.53-9.75,16.89-.7.39-1.42.74-2.16,1.04h-.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M124.12,37.96c-.72,0-1.42-.04-2.13-.11v5.51c0,6.87,3.64,13.17,9.48,16.45.6.33,1.21.64,1.85.9v-25.63c-1.83,1.38-4.82,2.9-9.2,2.9h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M142.67,37.96c-4.44,0-7.46-1.53-9.27-2.95l-.07.05v25.63l.07.03c.66-.27,1.29-.59,1.92-.93,5.85-3.27,9.49-9.57,9.49-16.45v-5.51c-.71.07-1.42.11-2.13.11h-.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M133.39,61.28c-.75-.29-1.46-.64-2.16-1.02-6.01-3.37-9.75-9.85-9.75-16.9v-6.08c.88.12,1.76.17,2.64.18,4.59,0,7.59-1.7,9.27-3.09,1.68,1.38,4.68,3.09,9.27,3.09.89,0,1.77-.06,2.64-.18v6.08c0,7.05-3.73,13.53-9.75,16.89-.7.39-1.42.74-2.16,1.04h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M145.82,36.69v6.66c0,7.24-3.83,13.88-10.01,17.33-.72.4-1.46.76-2.22,1.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.73,32.76l-.04.06v-.11s0,.02.04.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M122.94,46.25c-.08.23-.23.43-.43.59-.2.14-.44.22-.69.22l-2.67-.51c-.06-.39-.1-.8-.14-1.19h0c.36-.38,2.38-.15,2.38-.15l.93-1.42.21.16.4,2.31h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M123.58,49.83s-.06.48-.73.77l-2.76-.13c-.19-.58-.36-1.15-.51-1.74.33-.09.68-.14,1.02-.13.27.03,2.35-1.06,2.35-1.06l.18.15s.45,2.14.45,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M123.97,52.37c-.05.13-.13.25-.24.34-.1.09-.23.16-.36.21-.71.08-1.41.2-2.11.37-.19-.39-.37-.79-.54-1.19.13-.2.31-.35.52-.46.21-.1.45-.15.69-.14.34.04,1.55-.68,1.55-.68l.15.15.33,1.38h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M122.72,46.25l-.39-2.48-10.62-4.57.97,4.57s10.05,2.48,10.05,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M122.95,47.54l-8.27-1.93.71,3.25,7.99.91s-.42-2.23-.42-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M123.49,50.84l-5.63-.37.46,2.1,5.5-.28-.32-1.45h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M122.72,46.25c-.1.15-.24.27-.41.33s-.35.06-.53,0l-9.1-2.81,10.05,2.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M123.37,49.77c-.11.16-.26.29-.44.37-.18.08-.38.1-.58.06l-6.97-1.34,7.99.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M123.8,52.28c-.1.12-.23.21-.37.28-.14.06-.29.1-.45.09l-4.67-.09s5.5-.28,5.5-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M111.71,39.19l.45,2.13,10.38,3.76-.21-1.33-10.62-4.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.67,45.61l8.27,1.93.18.96-8.12-1.32s-.33-1.56-.33-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M117.85,50.46l5.63.37.15.68h-5.55s-.23-1.05-.23-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M143.84,46.25c.08.23.23.43.43.59.2.14.44.22.69.22l2.67-.51c.06-.39.1-.8.14-1.19h0c-.36-.38-2.38-.15-2.38-.15l-.93-1.42-.21.16s-.41,2.31-.41,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M143.2,49.83s.06.48.73.77l2.76-.13c.19-.58.36-1.15.51-1.74-.33-.09-.68-.14-1.02-.13-.27.02-2.35-1.06-2.35-1.06l-.18.15s-.45,2.14-.45,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M142.81,52.37c.05.13.13.25.24.34.1.09.23.16.36.21.71.08,1.41.2,2.11.37.19-.39.37-.79.54-1.19-.13-.19-.31-.35-.52-.46-.21-.1-.45-.15-.69-.14-.34.04-1.55-.68-1.55-.68l-.15.15-.33,1.38h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M144.06,46.25l.4-2.48,10.62-4.57-.97,4.57-10.05,2.48h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.83,47.54l8.27-1.93-.71,3.25-7.99.91s.42-2.23.42-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M143.31,50.84l5.63-.37-.46,2.1-5.5-.28.32-1.45h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M144.06,46.25c.1.15.24.27.41.33s.35.06.53,0l9.1-2.81-10.05,2.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M143.42,49.77c.11.16.26.29.44.37.18.08.38.1.58.06l6.98-1.34-8,.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M142.98,52.28c.1.12.23.21.37.28.14.06.29.1.45.09l4.67-.09-5.5-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M155.08,39.19l-.45,2.13-10.38,3.76.21-1.33,10.62-4.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M152.11,45.61l-8.27,1.93-.18.96,8.12-1.32s.33-1.56.33-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M148.94,50.46l-5.63.37-.15.68h5.55s.23-1.05.23-1.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "CQElL8Vpb1lB8WRiT6nbH"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M135.38,53.24s-.01,0-.01.01h.07s-.03-.01-.05-.01h-.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "X5jJSy3z82MTcyeIOeHYU"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M135.3,54.08h.03s-.02-.01-.03-.02h0v.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y3OTs6tMc4jRgRtEo4sco"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M136.23,51.68c.01-.32,0-.65-.06-.97h0c-.01-.12-.02-.21-.03-.27-.02-.11-.05-.22-.09-.33-.02-.07-.05-.14-.08-.21-.03-.07-.07-.14-.1-.2-.07-.13-.16-.23-.22-.29s-.09-.07-.06-.02c-.04-.05-.09-.1-.13-.14l-.04-.03-.04-.03s-.03-.02-.04-.03c0,0-.01,0-.02-.01,0,0-.01,0-.02-.01-.07-.03-.14-.05-.21-.05h-.06v-.03s0-.02.01-.03l.05-.13c.02-.06.05-.12.07-.18.03-.07.05-.14.08-.2.05-.14.11-.28.16-.41.05-.14.11-.28.17-.41l.04-.1s.03-.07.05-.1.03-.07.05-.1l.02-.05.03-.05v-.02s.02-.02.03-.02l.03-.05s.04-.07.05-.1c.04-.07.07-.13.1-.2.07-.13.13-.27.18-.41.1-.27.19-.54.26-.83,0-.04.01-.07.02-.1,0-.03,0-.07.01-.1,0-.07.01-.13.02-.19.01-.12.02-.24.02-.35v-.59s0-.08-.01-.13c0-.04,0-.08-.01-.12v-.12s-.01-.07-.02-.11l-.06-.4c-.02-.13-.04-.26-.06-.39-.01-.07-.02-.14-.04-.21-.01-.07-.03-.15-.05-.23s-.04-.16-.06-.25c-.01-.04-.02-.09-.04-.14-.01-.05-.03-.09-.04-.14s-.03-.1-.04-.15l-.05-.16c-.02-.06-.04-.11-.06-.17l-.03-.09-.03-.09c-.02-.06-.03-.12-.04-.18v-.16c0-.06-.02-.12-.04-.18s-.04-.12-.06-.19c-.02-.06-.04-.12-.07-.18-.02-.06-.05-.11-.07-.17l-.04-.08s-.01-.03-.02-.04l-.02-.04c-.03-.05-.05-.1-.08-.15-.01-.03-.03-.05-.04-.07l-.04-.07s-.05-.09-.08-.14l-.04-.07v-.02h-.02l-.03-.06-.02-.03h0s-.01-.01-.01-.01l-.05-.05s-.03-.02-.05-.03c-.01,0-.02-.02-.04-.02-.05-.03-.11-.06-.16-.08-.06-.03-.13-.04-.2-.05h-.18s-.04.01-.06.02c-.04.02-.07.05-.1.08l-.04.04s0,.02-.01.02c0,0,0,.02-.01.02-.03.06-.04.12-.05.18,0,.1,0,.2.04.3v.03l.02.03.02.06v.06s0,.04.01.06c.02.08.03.16.04.24,0,.08.01.16.01.24v.23c0,.12-.03.24-.07.36v.03s-.02.02-.02.03c0,.02-.01.04-.02.05-.01.03-.03.05-.04.05,0-.03,0-.09.02-.15,0-.06.02-.12.03-.19.02-.13.02-.28.02-.35,0-.02-.02-.03-.03-.05,0-.01-.02-.02-.02-.03-.01-.02-.03-.02-.04-.02-.02,0-.03.04-.03.1v.63c-.02.15-.05.31-.07.47s-.05.33-.08.49c-.05.32-.12.62-.19.83,0,.08.05-.06,0,.13.09-.4.19-.82.28-1.22.05.04-.03.51-.12,1.03-.04.24-.09.49-.12.72h0c-.07.29-.13.57-.18.81h0s-.03-.1-.03-.17c0-.06-.02-.09-.05,0-.03.07-.05.14-.07.21-.01.05-.03.12-.05.19h0v-.36c0-.1-.01-.21-.02-.31v-.08s-.01-.05-.01-.08c0-.05-.01-.11-.02-.16-.03-.21-.07-.42-.1-.62-.03-.16-.06-.31-.08-.45-.02-.06-.05-.12-.07-.18-.03-.07-.06-.14-.09-.21-.12-.3-.27-.66-.43-1.12-.07-.24.02-.04.06.03-.05-.12-.1-.25-.16-.38-.03-.06-.05-.13-.08-.19-.01-.03-.03-.06-.04-.1l-.02-.05-.02-.05s-.02-.06-.03-.08l-.04-.08c-.02-.06-.05-.11-.08-.17s-.05-.11-.08-.17l-.02-.04-.02-.04-.02-.05-.03-.05c-.07-.13-.14-.25-.23-.36-.04-.05-.08-.1-.13-.15-.04-.05-.09-.08-.15-.11-.01,0-.03-.01-.04-.02h-.04s-.07-.01-.1-.01-.06.03-.08.05c-.02.02-.04.05-.05.08-.03.06-.04.13-.04.19v.1s0,.07.01.1l.03.21s.01.07.02.11c0,.03.01.07.02.1,0,.03,0,.07.01.1s0,.07,0,.1v.2c0,.13,0,.27-.01.4,0,.04,0,.09-.01.13-.01.09-.03.18-.05.28-.18.78-.51,2.43-.51,2.43,0,0-.09.29-.16.74h0c.01-.12.03-.23.05-.33.01-.07.03-.15.04-.21,0-.03.01-.07.02-.1,0-.02,0-.03.01-.05v-.05s.03-.09.03-.13.01-.08.02-.12c.01-.07.02-.14.04-.2l-.1.44v.03l-.02.03s0-.05.01-.06v-.1s-.01.02-.02.03c0,0,0,.02-.01.03v.02h-.01v.03s-.01.03-.02.04c-.01.03-.02.05-.03.08-.02.05-.04.1-.05.12-.01.02-.02.02-.01-.02,0-.02,0-.05.01-.08,0,.02-.01.05-.02.07-.02.09-.04.18-.06.28-.04.19-.08.38-.11.59-.06.39-.09.81-.08,1.19,0,.09,0,.19.02.28,0,.05,0,.09.01.13v.19s0,.04.01.06,0,.04.01.06c0,.02,0,.04.01.06.02.08.04.15.06.22.01.03.02.07.03.1s.03.06.04.09c.02.05.05.11.08.16.01.02.03.04.04.06s.03.04.04.05c.02.03.05.06.08.08-.02-.03-.03-.06-.05-.09l-.02-.05s0-.02-.01-.02v-.02c-.04-.06-.06-.13-.09-.19,0-.05-.02-.09-.03-.15l-.02-.08v-.08c0-.06-.02-.11-.03-.17,0-.06-.02-.11-.02-.16-.02-.2-.02-.36.01-.33.03.21.08.42.13.63.05.23.13.46.23.68.75,1.57,1.09,2.14,1.11,2.41-.06.12-.22.43-.36,1.02h0v-.08s0-.02-.02,0c0-.03.02-.06.02-.09s.02-.05.03-.08c.02-.04.03-.07.05-.11.03-.11.06-.22.1-.34v-.04l.03-.04.02-.04.02-.04s.01-.03.02-.04l.02-.04s.02-.05.03-.07h0v-.07s-.02-.06-.03-.08c-.02-.06-.05-.12-.08-.17-.05-.11-.11-.23-.17-.34.01.05.03.11.04.16.03.1.06.19.1.29l.05.12s.01.03.02.05v.03h0v.02h0s-.01.04-.02.06v.03s-.02.02-.03.04c0,.02-.02.05-.03.07s-.02.05-.03.07c0-.01-.02,0-.03.01-.02.03-.04.07-.05.1-.04.09-.09.23-.13.38-.01.04-.02.08-.03.12s-.02.08-.03.12c-.02.08-.04.16-.05.24,0,.04-.02.08-.02.12s-.01.07-.02.11c0,.03-.01.06-.02.09,0,.02,0,.04-.01.06s0,.04,0,.06v.12h0c-.07,0-.14-.01-.2-.01h-.27c-.13,0-.27.02-.4.05-.08.02-.15.04-.22.07-.01,0-.02.01-.03.02s-.02.01-.03.02c-.01,0-.02.02-.04.03-.01.01-.02.03-.03.05h0c-.41.13-.77.44-.81,1.07h0v.15c0,.11.02.22.05.33.03.11.08.21.13.3.06.09.12.18.19.26l.14.14h0c.67.65,1.79.95,2.09,1.02h0s.03.01.05.02c.02,0,.04.01.06.02.04,0,.07.02.11.02.07.01.14.03.22.03.14.02.28.03.42.04h.13l.68.09s.08.01.12.02h-.14l.05.02c.06,0,.13.02.19.03.03,0,.06.01.09.02.03,0,.06.02.09.03.11.03.22.05.33.07h0c.46.1,1.11.14,1.5-.27.05-.05.1-.1.15-.14.18-.14.28-.2.31-.21.01,0,.03-.01.04-.02.15-.08.85-.43,1.05-.73.22-.33.76-1.1.34-2.04-.29-.67-1.25-.58-1.25-.58l-.12-.05ZM135.96,53.47v.03h0v.1s-.02.04-.01,0c0,.02-.01.03-.01.05s0,.04-.02.05c-.01,0,0-.03-.03.02-.02.03-.01.04,0,.04h0v.03s.01-.03.02-.04c0,.02,0,.03-.01.04,0,.02-.02.04-.03.05,0,0-.01.02-.02.03l-.02.03s-.03.03-.04.05c-.01,0-.02.02-.04.03h-.02v.02h-.01s-.03.02-.04.03c-.01,0-.03.02-.04.03,0,0,.02-.02,0-.02,0,0-.02,0-.02.01,0,0-.02.01-.02.02-.03.03.02,0,0,.02l-.02.02h-.01s-.01,0-.02.01h-.06s-.02-.01-.03-.02c0,0-.02-.01-.02-.02-.02,0-.05,0-.07-.03-.01,0-.03-.02-.04-.03-.01-.01-.03-.02-.04-.03l-.04-.04s-.04-.03-.04-.04c-.01-.01,0-.02,0-.03-.03-.03-.06-.05-.1-.09,0,.01,0,.04.02.06l-.02-.02s.07.08.03.06c-.02-.02-.03-.03-.04-.06,0-.02-.02-.04-.04-.05.02,0-.07-.07-.02-.06-.01-.01-.03-.02-.04-.04,0,0-.01,0-.02-.01.03.03,0,0,0,.02-.03-.02-.05-.04-.08-.07s-.05-.05-.07-.07l-.02-.02h0s-.04-.12,0-.16c0,0,.01-.01.02-.02.04-.03.07-.06.11-.09.04-.03.08-.05.12-.08.03,0,.04,0,.03,0,0,0,0,.02-.02.02.01,0,.02,0,.03-.01h.03s-.02.01-.03.02h0c.07-.02.14-.03.21-.04h.02s.03-.01,0-.02h-.1s0-.01.04-.02h.24s.04.03.08.05h-.04s.07,0,.11.02h.05c-.05-.02-.1-.03-.14-.04.06,0,.1,0,.15.01.05,0,.1.02.14.05.03.01.05.02.07.03h.01s.01,0,.02.01c.01.01.02.03.03.05,0,.01,0,0,0,0h0v.05h0s0,0,0,.01l-.03.1ZM135.14,53.24s-.03,0-.04.01h-.04s.06-.01.09-.01h-.01ZM135.6,53.23v-.02s.03.01.05.02h-.05ZM132.87,46.51h0c.07-.4.14-.72.19-1.05,0,.07-.01.14-.02.21-.02.12-.04.24-.07.38-.03.14-.06.3-.1.49v-.04ZM133.21,46.58v.29c0,.05,0,.09.01.14.01.09.02.17.04.25l.02-.08s.01.09.02.13c0,.04.01.08.02.12,0,.04.01.07.01.11,0,.03,0,.07.01.1.02.12.03.22.03.3.01.16,0,.24-.01.32v.05s-.01.02-.02.03v.17s0,.06.01.09v.06h0v.02s.01.06.03.09v-.09s.02.03.04.07.03.07.04.08v-.02s0-.08-.02-.12v-.03h0v-.11s0-.07.02-.1c.02-.05.06-.06.09-.07h0c.05.22.12.46.2.72-.36-.02-.85-.02-1.12.07-.02-.27-.03-.5-.02-.8.02-.04.04-.05.05-.03-.01.19-.02.24,0,.32,0-.03.01-.07.02-.07v.04s.01.03.01.05v.08-.53c.01-.18.04-.35.06-.53l.05.05c0-.08.01-.16.02-.24s.02-.15.02-.22.02-.14.03-.2c0-.07.02-.13.03-.19.04-.24.09-.45.13-.65.05-.19.1-.37.14-.55.01-.06.03-.12.04-.18v.05s-.01.09-.02.13v.14c0,.05-.01.1-.02.14v.61h.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GupAfj1q18hWzgXg4HhXG"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M134.79,53.43s.09-.07.14-.1c.02-.01.04-.02.06-.03-.04.01-.07.03-.11.05-.03.02-.06.05-.09.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "zNP1heBLSVlv3lttLJHmf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M135.92,53.44s-.02-.03-.03-.04c-.01,0-.02-.02-.04-.03h.02s.05.07.04.12c0,.04-.01.08-.02.12,0-.02.01-.03.02-.05h0v-.05h0v-.07h.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "KZpYS31L7MJhLx6xIIAjU"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M135.82,53.34v-.02h-.05s.02.01.01.01-.03,0-.04-.01c.04.01.07.03.1.05h0l-.02-.02h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "yS_y1pkHhARPSjavY4OR7",
    "data-name": "yS y1pkHhARPSjavY4OR7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M135.71,53.3h0s-.02-.01-.04-.01c.01,0,.03,0,.04.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_66U_i2ZX7tEsNWJTGkBY0",
    "data-name": " 66U i2ZX7tEsNWJTGkBY0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M130.4,43.8l.02-.06s.01-.06.02-.09c0-.03.01-.06.02-.09.01-.06.02-.12.03-.18-.02.08-.03.15-.04.21,0,.03-.01.06-.02.09v.06h0v.06s-.01.03-.02.05c0,.03-.01.05-.02.08v.02s0-.04.01-.06c0-.02.01-.04.02-.07l-.02-.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M1HyG8hIgLlS_o-AmeLBx",
    "data-name": "M1HyG8hIgLlS o-AmeLBx"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M133.17,42.9l.03.09c.02.06.04.11.05.16-.04-.14-.09-.28-.14-.41,0,.02,0,.04.01.07h0l.03.09h.02Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M14.97,32.69l-.45-1.58h-2.14l-.48,1.58h-1.99l2.47-8h2.6l2.51,8h-2.51ZM12.79,29.36h1.29l-.65-2.32-.65,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M20.7,29.78v2.91h-2.49v-8h3.42c.85,0,1.5.1,1.94.29s.79.49,1.05.9.39.85.39,1.35c0,.76-.27,1.38-.8,1.85s-1.24.7-2.13.7h-1.39ZM20.67,28.06h.82c.72,0,1.08-.27,1.08-.8,0-.5-.33-.75-1-.75h-.9v1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M33.05,32.69h-2.72l-1.17-3.06h-.77v3.06h-2.46v-8h4.18c.92,0,1.64.22,2.15.65s.76,1,.76,1.71c0,.46-.09.87-.28,1.22s-.57.67-1.14.93l1.45,3.49ZM28.38,27.92h1.05c.31,0,.56-.06.74-.19s.28-.32.28-.57c0-.51-.31-.77-.94-.77h-1.13v1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M38.45,32.69h-1.32v-8h2.3v2.75c.32-.55.83-.83,1.53-.83.49,0,.91.13,1.25.39s.6.63.77,1.1.25.98.25,1.51c0,.96-.21,1.74-.64,2.32s-1.07.88-1.92.88-1.48-.31-1.92-.94c-.12.23-.23.51-.3.82ZM39.44,30.47c0,.59.23.88.68.88.25,0,.43-.11.57-.32s.2-.65.2-1.32c0-.72-.07-1.18-.22-1.36s-.33-.28-.55-.28c-.17,0-.33.07-.46.2s-.21.33-.21.58v1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M47.09,32.81c-.99,0-1.77-.31-2.36-.92s-.87-1.34-.87-2.17c0-.89.3-1.63.91-2.23s1.4-.89,2.37-.89,1.77.29,2.36.88.89,1.32.89,2.2-.3,1.63-.91,2.23-1.41.89-2.41.89ZM47.12,31.39c.36,0,.58-.19.67-.57s.12-.77.12-1.18c0-.56-.06-.96-.17-1.21s-.32-.37-.61-.37c-.27,0-.47.13-.59.38s-.19.67-.19,1.25c0,.68.06,1.14.19,1.36s.32.33.58.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M54.22,32.81c-.99,0-1.77-.31-2.36-.92s-.87-1.34-.87-2.17c0-.89.3-1.63.91-2.23s1.4-.89,2.37-.89,1.77.29,2.36.88.89,1.32.89,2.2-.3,1.63-.91,2.23-1.41.89-2.41.89ZM54.25,31.39c.36,0,.58-.19.67-.57s.12-.77.12-1.18c0-.56-.06-.96-.17-1.21s-.32-.37-.61-.37c-.27,0-.47.13-.59.38s-.19.67-.19,1.25c0,.68.06,1.14.19,1.36s.32.33.58.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M57.91,31l1.85-.25c.11.43.52.64,1.25.64.61,0,.91-.12.91-.35,0-.1-.06-.18-.18-.24s-.39-.11-.83-.17c-1.21-.17-1.97-.43-2.27-.79s-.45-.75-.45-1.19c0-.61.25-1.1.76-1.48s1.17-.57,2-.57c1.45,0,2.37.52,2.77,1.56l-1.77.33c-.16-.35-.51-.53-1.04-.53-.25,0-.44.03-.56.1s-.18.14-.18.2c0,.2.19.31.56.36.98.11,1.64.22,1.99.33.35.11.64.32.89.62s.37.66.37,1.09c0,.65-.27,1.17-.82,1.55-.54.38-1.3.57-2.25.57-1.61,0-2.61-.6-2.99-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M68.53,26.73v1.52h-1.19v2.2c0,.3.06.48.17.54s.23.08.35.08c.19,0,.41-.03.67-.1v1.66c-.46.09-.91.13-1.36.13-.72,0-1.25-.15-1.58-.46s-.51-.8-.51-1.48v-.7s0-1.88,0-1.88h-.89v-1.52h.89l.04-1.94,2.22-.04v1.97h1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M13.39,47.21c-.99,0-1.77-.31-2.36-.92s-.87-1.34-.87-2.17c0-.89.3-1.63.91-2.23s1.4-.89,2.37-.89,1.77.29,2.36.88.89,1.32.89,2.2-.3,1.63-.91,2.23-1.41.89-2.41.89ZM13.42,45.79c.36,0,.58-.19.67-.57s.12-.77.12-1.18c0-.56-.06-.96-.17-1.21s-.32-.37-.61-.37c-.27,0-.47.13-.59.38s-.19.67-.19,1.25c0,.68.06,1.14.19,1.36s.32.33.58.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M23.43,47.09h-2.34v-3.75c0-.31-.05-.51-.14-.59s-.22-.13-.36-.13c-.43,0-.64.3-.64.89v3.58h-2.34v-5.96h2.17v.84c.32-.64.89-.97,1.72-.97.43,0,.8.08,1.1.25s.51.38.64.64.19.72.19,1.37v3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M33.66,47.09h-2.23c-.05-.25-.08-.53-.08-.83-.42.64-1.06.96-1.92.96-.7,0-1.23-.18-1.58-.54s-.52-.77-.52-1.24c0-.63.29-1.14.86-1.53s1.59-.62,3.04-.7v-.13c0-.26-.06-.44-.18-.52s-.29-.13-.52-.13c-.54,0-.84.22-.9.65l-2.13-.2c.3-1.25,1.34-1.87,3.11-1.87.48,0,.92.05,1.32.14s.72.25.96.45.39.42.47.64.12.66.12,1.31v2.38c0,.45.06.84.18,1.16ZM31.24,44.3c-1,.11-1.49.42-1.49.96,0,.36.2.54.59.54.25,0,.46-.07.64-.22s.26-.48.26-.98v-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M37,39.09v8h-2.3v-8h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M40.53,39.09v8h-2.3v-8h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M47.1,48.97h-2.34v-7.84h2.15v.84c.3-.64.86-.97,1.68-.97.71,0,1.27.28,1.67.83s.6,1.31.6,2.26-.21,1.71-.62,2.27-.96.84-1.63.84-1.17-.25-1.52-.76v2.52ZM47.1,44.91c0,.27.06.47.18.62s.27.22.45.22c.28,0,.47-.13.58-.39s.16-.66.16-1.2c0-.62-.06-1.06-.18-1.31s-.3-.38-.54-.38c-.14,0-.29.06-.43.17s-.21.3-.21.56v1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M54.71,47.21c-.99,0-1.77-.31-2.36-.92s-.87-1.34-.87-2.17c0-.89.3-1.63.91-2.23s1.4-.89,2.37-.89,1.77.29,2.36.88.89,1.32.89,2.2-.3,1.63-.91,2.23-1.41.89-2.41.89ZM54.74,45.79c.36,0,.58-.19.67-.57s.12-.77.12-1.18c0-.56-.06-.96-.17-1.21s-.32-.37-.61-.37c-.27,0-.47.13-.59.38s-.19.67-.19,1.25c0,.68.06,1.14.19,1.36s.32.33.58.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M61.84,47.21c-.99,0-1.77-.31-2.36-.92s-.87-1.34-.87-2.17c0-.89.3-1.63.91-2.23s1.4-.89,2.37-.89,1.77.29,2.36.88.89,1.32.89,2.2-.3,1.63-.91,2.23-1.41.89-2.41.89ZM61.87,45.79c.36,0,.58-.19.67-.57s.12-.77.12-1.18c0-.56-.06-.96-.17-1.21s-.32-.37-.61-.37c-.27,0-.47.13-.59.38s-.19.67-.19,1.25c0,.68.06,1.14.19,1.36s.32.33.58.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M68.36,39.09v8h-2.3v-8h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M69.06,45.4l1.85-.25c.11.43.52.64,1.25.64.61,0,.91-.12.91-.35,0-.1-.06-.18-.18-.24s-.39-.11-.83-.17c-1.21-.17-1.97-.43-2.27-.79s-.45-.75-.45-1.19c0-.61.25-1.1.76-1.48s1.17-.57,2-.57c1.45,0,2.37.52,2.77,1.56l-1.77.33c-.16-.35-.51-.53-1.04-.53-.25,0-.44.03-.56.1s-.18.14-.18.2c0,.2.19.31.56.36.98.11,1.64.22,1.99.33.35.11.64.32.89.62s.37.66.37,1.09c0,.65-.27,1.17-.82,1.55-.54.38-1.3.57-2.25.57-1.61,0-2.61-.6-2.99-1.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M10.8,63.63c.39.24.96.44,1.56.44.89,0,1.41-.47,1.41-1.15,0-.63-.36-.99-1.27-1.34-1.1-.39-1.78-.96-1.78-1.91,0-1.05.87-1.83,2.18-1.83.69,0,1.19.16,1.49.33l-.24.71c-.22-.12-.67-.32-1.28-.32-.92,0-1.27.55-1.27,1.01,0,.63.41.94,1.34,1.3,1.14.44,1.72.99,1.72,1.98,0,1.04-.77,1.94-2.36,1.94-.65,0-1.36-.19-1.72-.43l.22-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M19.87,63.37c0,.5.01.94.04,1.32h-.78l-.05-.79h-.02c-.23.39-.74.9-1.6.9-.76,0-1.67-.42-1.67-2.12v-2.83h.88v2.68c0,.92.28,1.54,1.08,1.54.59,0,1-.41,1.16-.8.05-.13.08-.29.08-.45v-2.97h.88v3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M21.29,64.69c.02-.33.04-.82.04-1.25v-5.85h.87v3.04h.02c.31-.54.87-.89,1.65-.89,1.2,0,2.05,1,2.04,2.47,0,1.73-1.09,2.59-2.17,2.59-.7,0-1.26-.27-1.62-.91h-.03l-.04.8h-.76ZM22.2,62.75c0,.11.02.22.04.32.17.61.68,1.03,1.32,1.03.92,0,1.47-.75,1.47-1.86,0-.97-.5-1.8-1.44-1.8-.6,0-1.16.41-1.34,1.08-.02.1-.05.22-.05.36v.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M26.9,63.79c.26.17.72.35,1.16.35.64,0,.94-.32.94-.72s-.25-.65-.9-.89c-.87-.31-1.28-.79-1.28-1.37,0-.78.63-1.42,1.67-1.42.49,0,.92.14,1.19.3l-.22.64c-.19-.12-.54-.28-.99-.28-.52,0-.81.3-.81.66,0,.4.29.58.92.82.84.32,1.27.74,1.27,1.46,0,.85-.66,1.45-1.81,1.45-.53,0-1.02-.13-1.36-.33l.22-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M34.43,64.51c-.23.12-.74.28-1.39.28-1.46,0-2.41-.99-2.41-2.47s1.02-2.57,2.6-2.57c.52,0,.98.13,1.22.25l-.2.68c-.21-.12-.54-.23-1.02-.23-1.11,0-1.71.82-1.71,1.83,0,1.12.72,1.81,1.68,1.81.5,0,.83-.13,1.08-.24l.15.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M35.46,61.36c0-.57,0-1.06-.04-1.51h.77l.03.95h.04c.22-.65.75-1.06,1.34-1.06.1,0,.17,0,.25.03v.83c-.09-.02-.18-.03-.3-.03-.62,0-1.06.47-1.18,1.13-.02.12-.04.26-.04.41v2.58h-.87v-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M39.75,58.49c.01.3-.21.54-.56.54-.31,0-.53-.24-.53-.54s.23-.55.55-.55.54.24.54.55ZM38.77,64.69v-4.84h.88v4.84h-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M41.07,64.69c.02-.33.04-.82.04-1.25v-5.85h.87v3.04h.02c.31-.54.87-.89,1.65-.89,1.2,0,2.05,1,2.04,2.47,0,1.73-1.09,2.59-2.17,2.59-.7,0-1.26-.27-1.62-.91h-.03l-.04.8h-.76ZM41.98,62.75c0,.11.02.22.04.32.17.61.68,1.03,1.32,1.03.92,0,1.47-.75,1.47-1.86,0-.97-.5-1.8-1.44-1.8-.6,0-1.16.41-1.34,1.08-.02.1-.05.22-.05.36v.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M47.29,62.43c.02,1.19.78,1.68,1.66,1.68.63,0,1.01-.11,1.34-.25l.15.63c-.31.14-.84.3-1.61.3-1.49,0-2.38-.98-2.38-2.44s.86-2.61,2.27-2.61c1.58,0,2,1.39,2,2.28,0,.18-.02.32-.03.41h-3.4ZM49.87,61.8c.01-.56-.23-1.43-1.22-1.43-.89,0-1.28.82-1.35,1.43h2.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M58.1,61.75c0,.07-.02.14-.06.19l-1.77,2.66c-.06.1-.17.16-.29.16h-1.06c-.19,0-.35-.16-.35-.35,0-.07.02-.14.06-.19l1.64-2.46-1.64-2.46c-.04-.05-.06-.12-.06-.19,0-.19.16-.35.35-.35h1.06c.12,0,.23.06.29.16l1.77,2.66c.04.05.06.12.06.19ZM61.64,61.75c0,.07-.02.14-.06.19l-1.77,2.66c-.06.1-.17.16-.29.16h-1.06c-.19,0-.35-.16-.35-.35,0-.07.02-.14.06-.19l1.64-2.46-1.64-2.46c-.04-.05-.06-.12-.06-.19,0-.19.16-.35.35-.35h1.06c.12,0,.23.06.29.16l1.77,2.66c.04.05.06.12.06.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M65.19,61.75c0,.07-.02.14-.06.19l-1.77,2.66c-.06.1-.17.16-.29.16h-1.06c-.19,0-.35-.16-.35-.35,0-.07.02-.14.06-.19l1.64-2.46-1.64-2.46c-.04-.05-.06-.12-.06-.19,0-.19.16-.35.35-.35h1.06c.12,0,.23.06.29.16l1.77,2.66c.04.05.06.12.06.19ZM68.73,61.75c0,.07-.02.14-.06.19l-1.77,2.66c-.06.1-.17.16-.29.16h-1.06c-.19,0-.35-.16-.35-.35,0-.07.02-.14.06-.19l1.64-2.46-1.64-2.46c-.04-.05-.06-.12-.06-.19,0-.19.16-.35.35-.35h1.06c.12,0,.23.06.29.16l1.77,2.66c.04.05.06.12.06.19h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M21.11,2.83h-3.78c0-.37.07-1.22.54-2.01.23-.4.49-.66.69-.82h2.55v2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M36.23,2.83h3.78c0-.37-.07-1.22-.54-2.01-.23-.4-.49-.66-.69-.82h-2.55v2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.53,20.79l-8.59-5.91V2.36c0-1.32-.79-2.13-1.19-2.36h19.8c-.95,0-1.19,1.57-1.19,2.36v12.52l-8.82,5.91Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M25.43,7.91v.99h-1.45v1.5h-1v-1.5h-1.45v-.99h1.45v-1.5h1v1.5h1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M29.93,7.08h-2.23l-.06.75c.29-.2.61-.3.96-.3.46,0,.87.16,1.21.48s.52.74.52,1.27c0,.56-.2,1.02-.61,1.37s-.92.53-1.55.53c-.55,0-1.02-.14-1.42-.43s-.65-.69-.74-1.21l1.38-.17c.09.39.34.58.75.58.21,0,.37-.06.48-.19s.17-.28.17-.46c0-.2-.07-.36-.2-.48s-.29-.17-.47-.17c-.27,0-.48.11-.62.34l-1.22-.17.23-3.06h3.56l-.14,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M31.84,8.47c-.33,0-.59-.13-.79-.38s-.29-.59-.29-1,.1-.76.3-1,.46-.37.79-.37.61.13.8.39.28.59.28,1-.1.75-.3.99-.46.37-.79.37ZM35.34,5.76l-3.24,5.33h-.74l3.26-5.33h.71ZM31.84,7.88c.18,0,.28-.26.28-.78,0-.24-.02-.43-.05-.58-.04-.15-.11-.22-.22-.22-.18,0-.27.25-.27.75,0,.31.02.53.06.65s.11.18.21.18ZM34.87,11.13c-.33,0-.59-.13-.78-.38s-.29-.58-.29-1,.1-.76.3-1,.46-.37.79-.37.58.12.78.36.3.59.3,1.03c0,.41-.1.74-.3.99-.2.24-.47.37-.79.37ZM34.88,10.55c.19,0,.28-.26.28-.78,0-.24-.02-.43-.05-.58s-.11-.22-.22-.22c-.18,0-.28.25-.28.75,0,.32.02.54.06.65s.11.18.21.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPremium);
export default __webpack_public_path__ + "static/media/sidebarPremium.a74b41cf5b1dda51dab922073781ea0e.svg";
export { ForwardRef as ReactComponent };